const noDataIcon = require('../images/icons/no-data.svg')
export default ()=>{
    return <div className="empty-data">
            <img src={noDataIcon} alt="No data icon"/>
        </div>
}